import "core-js/modules/es.object.keys.js";
import i18n from '@/pages/design/locales';
import { mapState } from "vuex";
export default {
  props: {
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      // defaultLangId: 0,
      i18n: i18n
    };
  },
  created: function created() {
    var defaultLangObjStr = window.localStorage.cdefaultLangObj ? window.localStorage.cdefaultLangObj : window.localStorage.defaultLangObj;
    var defaultLangObj = JSON.parse(defaultLangObjStr);
    // let defaultLangObj = JSON.parse(localStorage.defaultLangObj)
    if (defaultLangObj) {
      this.defaultLangId = defaultLangObj.langId;
    }
    var lang = localStorage.langCode;
    this.i18n.locale = lang;
    this.$t = this.i18n.t.bind(this.i18n);
  }
};